<template>
    <!-- Componente para mostar las promociiones de post venta -->
    <div
        class="mt-10 mx-auto w-11/12 lg:w-9/12"
        :class="{ 'hidden': psPromotions.length === 0 }"
    >
        <VueSlickCarousel
            v-if="psPromotions.length > 0"
            ref="carousel"
            v-bind="slickOptions"
        >
            <div
                v-for="(promotion, index) in psPromotions"
                :key="index"
                class="info "
            >
                <div class="flex bg-dark-blue h-40 sm:h-48">
                    <div class="left w-1/2">
                        <img
                            class="w-full h-full object-cover object-top"
                            :src="`${url}/storage${promotion.mobile}`"
                            :alt="promotion.title"
                        >
                    </div>
                    <div class="right w-1/2 text-white px-4 sm:pl-6 sm:pr-16 py-2 sm:py-6">
                        <h3 class="font-bold text-sm sm:text-base leading-tight mb-1 sm:mb-2">{{ promotion.title }}</h3>
                        <p class="text-xs sm:text-sm leading-tight">{{ promotion.description }}</p>
                        <a
                            class="underline text-xs sm:text-sm"
                            target="_blank"
                            :href="`${promotion.tyc}`"
                        >Términos y condiciones</a>
                    </div>
                </div>
            </div>
            <template #customPaging="page">
                <div
                    class="custom-dot h-2 w-2 sm:h-3 sm:w-3 bg-white rounded-lg border-brown border-solid border box-content">
                </div>
            </template>
        </VueSlickCarousel>
        <div
            v-if="psPromotions.length === 1"
            class="slick-dots"
        >
            <div
                class="custom-dot h-2 w-2 sm:h-3 sm:w-3 bg-light-blue rounded-lg border-brown border-solid border box-content">
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    components: { VueSlickCarousel },
    data() {
        return {
            url: $('.url').text(),
            webpage: $('.webpage').text(),
            // Variable para almacenar las opciones del slider
            slickOptions: {
                arrows: false,
                dots: true,
                autoplay: true,
                speed: 2000,
                autoplaySpeed: 5000,
            },
            // Variable para almacenar las promociones de post venta
            psPromotions: [],
        }
    },
    methods: {
        // Función para obtener las promociones de post venta desde el back
        getPsPromotions() {
            axios.get(`${this.url}/${this.webpage}/get-postsale-promotions`)
                .then(resp => {
                    // console.log(resp.data)
                    this.psPromotions = resp.data
                    this.psPromotions.forEach(promo => {
                        if (promo.tyc.search('https') == -1) promo.tyc = `${this.url}/${this.webpage}${promo.tyc}`
                    });
                })
                .catch(err => {
                    console.log(err)
                })
        }
    },
    beforeMount() {
        this.getPsPromotions()
    }
}
</script>

<style lang="scss">
.slick-dots {
    display: flex !important;
    justify-content: center;
    padding: 1rem 0;

    li {
        margin: 0 0.25rem;

        &.slick-active {
            .custom-dot {
                background-color: #00aad2;
            }
        }
    }
}

// @media only screen and (min-width: 1024px) {
//     .slick-dots {
//         padding: 1rem 0;
//     }
// }
</style>